import MetaSelect from './index';

/**
 * Select class for <select> in filters
 * @see select--filter.html.twig
 */
export default class MetaFilterSelect extends MetaSelect {
  /**
   * Component configuration
   */
  get config() {
    return {
      name: 'FilterSelect',
    };
  }

  /**
   * Update the native Drupal <select> this.$refs.select
   * @param {string} value ElementUi Select component new value.
   * @see Select.vue to view the $emit function
   */
  updateChange(value) {
    Array.from(this.$refs.select.querySelectorAll('option')).forEach((option) => {
      option.selected = false;
    });

    if (value) {
      // Select the correct <option>
      const option = this.$refs.select.querySelector(`option[value="${value}"]`);
      if (option) {
        option.selected = 'selected';
      }
    }

    // Manually trigger change event in order to have Drupal making the request
    this.$refs.select.dispatchEvent(new Event('change'));
  }
}
